export var SETTING_MENU;
(function (SETTING_MENU) {
    SETTING_MENU["ADMIN"] = "ADMIN";
    SETTING_MENU["APPLICATION"] = "APPLICATION";
    SETTING_MENU["USER"] = "USER";
})(SETTING_MENU || (SETTING_MENU = {}));
export var ADMIN_SETTING_MENU;
(function (ADMIN_SETTING_MENU) {
    ADMIN_SETTING_MENU["USER_CONFIGURATION"] = "USER_CONFIGURATION";
    ADMIN_SETTING_MENU["ORGANIZATIONS"] = "ORGANIZATIONS";
    ADMIN_SETTING_MENU["PRODUCTS"] = "PRODUCTS";
})(ADMIN_SETTING_MENU || (ADMIN_SETTING_MENU = {}));
export var USER_SETTING_MENU;
(function (USER_SETTING_MENU) {
    USER_SETTING_MENU["PROFILE"] = "PROFILE";
    USER_SETTING_MENU["THEME_AND_APPEARANCE"] = "THEME_AND_APPEARANCE";
    USER_SETTING_MENU["SECURITY"] = "SECURITY";
})(USER_SETTING_MENU || (USER_SETTING_MENU = {}));
export var dummyMenu = function (t) { return [
    {
        category_id: SETTING_MENU.ADMIN,
        category_name: t('settings:category.admin.title'),
        subCategorys: [
            {
                title: t('settings:category.admin.organizations'),
                id: ADMIN_SETTING_MENU.ORGANIZATIONS,
            },
            {
                title: t('settings:category.admin.products'),
                id: ADMIN_SETTING_MENU.PRODUCTS,
            },
            {
                title: t('settings:category.admin.userConfiguration'),
                id: ADMIN_SETTING_MENU.USER_CONFIGURATION,
            },
            // {
            //   title: t('settings:category.admin.roles'),
            //   id: 'ROLES',
            // },
        ],
    },
    // {
    //   category_id: SETTING_MENU.APPLICATION,
    //   category_name: t('settings:category.application.title'),
    //   subCategorys: [
    //     {
    //       title: t('settings:category.application.nec_integration_settings'),
    //       id: 'NEC_INTEGRATION_SETTINGS',
    //     },
    //     {
    //       title: t('settings:category.application.general_cms_settings'),
    //       id: 'GENERAL_CMS_SETTINGS',
    //     },
    //     {
    //       title: t('settings:category.application.pid_settings'),
    //       id: 'PID_SETTINGS',
    //     },
    //     {
    //       title: t('settings:category.application.alert_thresholds'),
    //       id: 'ALERT_THRESHOLDS',
    //     },
    //     {
    //       title: t('settings:category.application.default_pid_settings'),
    //       id: 'DEFAULT_PID_SETTINGS',
    //     },
    //   ],
    // },
    {
        category_id: SETTING_MENU.USER,
        category_name: t('settings:category.user.title'),
        subCategorys: [
            {
                title: t('settings:category.user.profile'),
                id: USER_SETTING_MENU.PROFILE,
            },
            {
                title: t('settings:category.user.theme'),
                id: USER_SETTING_MENU.THEME_AND_APPEARANCE,
            },
            {
                title: t('settings:category.user.security'),
                id: USER_SETTING_MENU.SECURITY,
            },
        ],
    },
]; };
